module.exports = __webpack_public_path__ + "img/596-42dfb3.png";